import api from "@/api/api-v2-config";



export async function getProviderName(data) {
    return api.post("marketings/smtpprovider", data);
}

export async function testsmtp(data) {
    return api.post("marketings/testsmtpsettings", data);
}

export async function createProvider(data) {
    return api.post("marketings/createsmtpsettings", data);
}


export async function updateProvider(data) {
    return api.put("marketings/updatesmtpsettings", data);
}

export async function deleteProvider(id) {
    return api.delete("marketings/deletesmtpsettings?id=" + id);
}


export async function getProviders() {
    return api.get("marketings/getsmtpsettingslist?PageNumber=1&PageSize=10000");
}
